import request from '@/utils/http.js';

// 观看端-获取【未互动踢出】规则
const getInactiveKickRule = params => {
  return request('/v3/interacts/user-kick/get-inactive-kick-rule', {
    method: 'GET',
    params
  });
}

// 观看端-设置【未互动踢出】规则
const setInactiveKickRule = params => {
  return request('/v3/interacts/user-kick/set-inactive-kick-rule', {
    method: 'POST',
    data: params
  });
}

// 取消【未互动踢出】规则
const cancelInactiveKickRule = params => {
  return request('/v3/interacts/user-kick/cancel-inactive-kick-rule', {
    method: 'POST',
    data: params
  });
}
export default {
  getInactiveKickRule,
  setInactiveKickRule,
  cancelInactiveKickRule
}